import { select, take } from 'redux-saga/effects';

import { selectors as cartSelectors, types as cartTypes } from '../../store/cart';

export const getDeliveryMode = function*() {
    let cartDeliveryMode = yield select(cartSelectors.getDeliveryMode);

    if (!cartDeliveryMode.code) {
        yield take(cartTypes.SET_CART_DATA);
        cartDeliveryMode = yield select(cartSelectors.getDeliveryMode);
    }

    return cartDeliveryMode;
};
